var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, customElement, html, css } from 'lit-element';
import CSTStyles from '../../styles/cst-styles/cst-styles';
let CSTHeaderElement = class CSTHeaderElement extends LitElement {
    render() {
        return html `
      <nav>
        <a href="/">
          Car Service Tracker
        </a>
        <spacer></spacer>
        <a href="/settings">
          Settings
        </a>
      </nav>
    `;
    }
};
CSTHeaderElement.styles = css `
    ${CSTStyles}
    :host {
      display: flex;
      align-items: center;
      height: 55px;
      border-bottom: 1px solid #eee;
    }

    nav {
      display: flex;
      flex: 1 1 auto;
      margin: 0 24px;
    }

    spacer {
      display: flex;
      flex: 1 1 auto;
    }
  `;
CSTHeaderElement = __decorate([
    customElement('cst-header')
], CSTHeaderElement);
export default CSTHeaderElement;
//# sourceMappingURL=cst-header.js.map